module.exports = __webpack_public_path__ + "img/GeneralGroupSeatingMap.0bfe4d31.jpg";